import Card from '../ui/Card';
import useProxiesInPool from '@/hooks/queries/useProxiesInPool';
import usePoolById from '@/hooks/queries/usePoolById';
import formatProxies from '@/utils/formatProxies';

export default function ProxiesText({
  poolId,
  format,
}: {
  poolId: number;
  format: string;
}) {
  const { data: proxies } = useProxiesInPool(poolId);
  const { data: pool } = usePoolById(poolId);

  return (
    <>
      {pool && proxies && (
        <Card className="bg-primary-background p-5 text-secondary w-full sm:w-full sm:max-h-none ">
          <pre className='overflow-y-scroll max-h-[80vh] scrollbar-thin scrollbar-track-primary-background scrollbar-thumb-gray-300'>{formatProxies(proxies, pool, format)}</pre>
        </Card>
      )}
    </>
  );
}
